import { render, staticRenderFns } from "./ExerciseContent.vue?vue&type=template&id=fd8ffe8c&scoped=true"
import script from "./ExerciseContent.vue?vue&type=script&lang=js"
export * from "./ExerciseContent.vue?vue&type=script&lang=js"
import style0 from "./ExerciseContent.vue?vue&type=style&index=0&id=fd8ffe8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8ffe8c",
  null
  
)

export default component.exports